import { calcScrollbarWidth } from '$core/helpers/calc-scrollbar-width';
import { EyeSightService } from '$core/services/eye-sight.service';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';

export enum Overlays {
  None,
  Menu,
  Search,
}

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  public change$ = new BehaviorSubject<Overlays>(this.isOpen);

  private _isOpen: Overlays;
  public set isOpen(value: Overlays) {
    this._isOpen = value;
    this.change$.next(value);
  }
  public get isOpen(): Overlays {
    return this._isOpen;
  }

  private renderer: Renderer2;
  constructor(
    private rendererFactory: RendererFactory2,
    private router: Router,
    private eyeService: EyeSightService
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);

    this.change$.subscribe((e) => {
      if (e === null) {
        return;
      }

      this.handleStyle();
    });

    this.eyeService.status$.pipe(skip(1)).subscribe((e) => {
      if (e) {
        this.removeStyles();
      } else {
        this.handleStyle();
      }
    });

    this.checkRouterEvents();
  }

  public open(val: Overlays) {
    this.isOpen = val;
  }

  public close() {
    this.isOpen = Overlays.None;
  }

  public toggle(val: Overlays) {
    if (this.isOpen === val) {
      this.isOpen = Overlays.None;
    } else {
      this.isOpen = val;
    }
  }

  private preventEvent(e: Event) {
    e.preventDefault();
  }

  private handleStyle() {
    if (this.isOpen) {
      if (this.eyeService.enabled) {
        return;
      }

      this.renderer.setStyle(document.documentElement, 'overflow', 'hidden');
      this.renderer.setStyle(document.body, 'overflow', 'hidden');
      this.renderer.setStyle(
        document.body,
        'padding-right',
        `${calcScrollbarWidth()}px`
      );

      document.addEventListener('touchmove', this.preventEvent, {
        passive: false,
      });
    } else {
      this.removeStyles();
    }
  }

  private removeStyles() {
    this.renderer.removeStyle(document.documentElement, 'overflow');
    this.renderer.removeStyle(document.body, 'overflow');
    this.renderer.removeStyle(document.body, 'padding-right');
    document.removeEventListener('touchmove', this.preventEvent);
  }

  private checkRouterEvents() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.close();
      }
    });
  }
}
